import { api } from "./client";
import type { AuditLogEntry, AuditLogFilters, Paginated } from "./types";

function buildQuery(filters: AuditLogFilters): string {
  const params = new URLSearchParams();
  if (filters.actor) params.set("actor", filters.actor);
  if (filters.action) params.set("action", filters.action);
  if (filters.entityType) params.set("entityType", filters.entityType);
  if (filters.entityId) params.set("entityId", filters.entityId);
  if (filters.dateFrom) params.set("dateFrom", filters.dateFrom);
  if (filters.dateTo) params.set("dateTo", filters.dateTo);
  if (filters.requestId) params.set("requestId", filters.requestId);
  if (filters.page) params.set("page", String(filters.page));
  if (filters.pageSize) params.set("pageSize", String(filters.pageSize));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

/** docs/API_CONTRACT.md - GET /api/admin/audit (filters: actor, action, entity type, entity id, date range, request id) */
export function listAuditLog(
  filters: AuditLogFilters = {},
): Promise<Paginated<AuditLogEntry>> {
  return api.get<Paginated<AuditLogEntry>>(`/admin/audit${buildQuery(filters)}`);
}
